import { useQuery } from "@tanstack/react-query";
import artistsBriefsClient from "../../api/artists-briefs";
import newArtistsClient, {
  NEW_ARTISTS_SUBMISSIONS_QUERY_KEY,
} from "../../api/new-artists";
import firebaseService from "../../firebase_service/firebaseService";

const BRIEF_SUBMISSIONS_LAST_VISIT_KEY =
  "artists_briefs_submissions_last_visit";
const NEW_ARTISTS_CONTACT_LAST_VISIT_KEY =
  "new_artists_contact_submissions_last_visit";

function getStorageKey(key: string) {
  const userId = firebaseService.getUserId();
  return `${key}_${userId}`;
}

function getLastVisit(key: string): number {
  const value = localStorage.getItem(getStorageKey(key));
  return value ? Number(value) : 0;
}

export function markBriefSubmissionsVisited() {
  localStorage.setItem(
    getStorageKey(BRIEF_SUBMISSIONS_LAST_VISIT_KEY),
    String(Date.now()),
  );
}

export function markNewArtistsContactVisited() {
  localStorage.setItem(
    getStorageKey(NEW_ARTISTS_CONTACT_LAST_VISIT_KEY),
    String(Date.now()),
  );
}

const hasUnseenSubmissions = (
  submissions: Array<{ createdAt?: string }>,
  lastVisit: number,
): boolean => {
  if (submissions.length === 0) return false;
  if (lastVisit === 0) return true;
  return submissions.some(
    (submission) =>
      submission.createdAt &&
      new Date(submission.createdAt).getTime() > lastVisit,
  );
};

export const useHasNewBriefSubmissions = () => {
  return useQuery<boolean>({
    queryKey: ["newBriefSubmissions"],
    queryFn: async () => {
      const lastVisit = getLastVisit(BRIEF_SUBMISSIONS_LAST_VISIT_KEY);
      const submissions = await artistsBriefsClient.getSubmissions();
      return hasUnseenSubmissions(submissions, lastVisit);
    },
  });
};

export const useHasNewArtistsContactSubmissions = () => {
  return useQuery({
    queryKey: NEW_ARTISTS_SUBMISSIONS_QUERY_KEY,
    queryFn: () => newArtistsClient.getSubmissions(),
    staleTime: 60_000,
    select: (submissions) =>
      hasUnseenSubmissions(
        submissions,
        getLastVisit(NEW_ARTISTS_CONTACT_LAST_VISIT_KEY),
      ),
  });
};
